import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=829c2326&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=829c2326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829c2326",
  null
  
)

export default component.exports